import { Navigate, useLocation } from 'react-router-dom';
import { loginPath } from '../../constants';
import useAuthUser from './useAuthUser';

const RequireAuth = () => {
  const location = useLocation();
  const { user, loading } = useAuthUser();

  // Still waiting on Firebase to resolve the current session - render
  // nothing rather than redirecting, so an already-signed-in admin doesn't
  // get bounced to /login for a moment on every page load.
  if (loading) {
    return <div></div>;
  }

  if (!user) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return <div></div>;
};

export default RequireAuth;
